import * as React from "react";
import { AccordionItem, Button, Flex, Form } from "components";
import { ToothDiagnosisInputs, ToothDiagnosisRadio } from "../../../shared";
import { useDentalChart } from "../../duck";
import { Legend, Other } from "./components";
import {
  CALCULUS_OPTIONS,
  EMPTY_FORM_VALUES,
  ENAMEL_OPTIONS,
  FormValues,
  FRACTURE_OPTIONS,
  FURCATION_OPTIONS,
  getDefaultValues,
  GINGIVITIS_OPTIONS,
  MOBILITY_OPTIONS,
  PERIODONTAL_OPTIONS,
  RESORPTION_OPTIONS,
  TOOTH_STATE_OPTIONS,
  useUpdateDiagnosis
} from "./duck";

const Diagnosis: React.FC = () => {
  const dentalChart = useDentalChart();

  const defaultValues = React.useMemo(
    () => getDefaultValues(dentalChart || null),
    [dentalChart]
  );

  const onChange = useUpdateDiagnosis(
    dentalChart?._id || null,
    dentalChart?.fakeId || null
  );

  if (!defaultValues) {
    return null;
  }

  return (
    <AccordionItem title="Diagnosis">
      <Form<FormValues> defaultValues={defaultValues}>
        {({ reset }) => (
          <>
            <Form.Watcher defaultValues={defaultValues} onChange={onChange} />
            <Flex justifyContent="flex-end" gridGap="16px" mb="24px">
              <Legend />
              <Button onClick={() => reset(EMPTY_FORM_VALUES)}>
                Clear Selection
              </Button>
            </Flex>

            <Flex mb="24px" gridGap="24px" flexDirection="column">
              <ToothDiagnosisInputs
                label="Periodontal Pocket (mm)"
                namePrefix="periodontalPocket"
              />
              <ToothDiagnosisInputs
                label="Gingival Recession (mm)"
                namePrefix="gingivalRecession"
              />
            </Flex>

            <Flex gridGap="60px" flexWrap="wrap">
              <ToothDiagnosisRadio
                label="Tooth State"
                name="toothState"
                options={TOOTH_STATE_OPTIONS}
              />

              <ToothDiagnosisRadio
                label="Periodontal"
                name="periodontal"
                options={PERIODONTAL_OPTIONS}
              />

              <ToothDiagnosisRadio
                label="Furcation"
                name="furcation"
                options={FURCATION_OPTIONS}
              />

              <ToothDiagnosisRadio
                label="Mobility"
                name="mobility"
                options={MOBILITY_OPTIONS}
              />

              <ToothDiagnosisRadio
                label="Gingivitis"
                name="gingivitis"
                options={GINGIVITIS_OPTIONS}
              />

              <ToothDiagnosisRadio
                label="Calculus"
                name="calculus"
                options={CALCULUS_OPTIONS}
              />

              <ToothDiagnosisRadio
                label="Enamel"
                name="enamel"
                options={ENAMEL_OPTIONS}
              />

              <ToothDiagnosisRadio
                label="Fracture"
                name="fracture"
                options={FRACTURE_OPTIONS}
              />

              <ToothDiagnosisRadio
                label="Resorption"
                name="resorption"
                options={RESORPTION_OPTIONS}
              />

              <Other />
            </Flex>
          </>
        )}
      </Form>
    </AccordionItem>
  );
};

export default Diagnosis;
